/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import useApiInventariosCaja from "../../api/taller/useApiInventariosCaja";
import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import FormCheckBox from "../../shared/forms/FormFields/FormCheckBox";
import {Button} from "primereact/button";
import Form from "../../shared/forms/Form";
import {Dialog} from "primereact/dialog";
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../../catalogos/constantes";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const InventarioCajaDetalle = ({ id, onCancel, onSaved, disabled }) => {
    const api = useApiInventariosCaja();
    const visible = id != null;
    const seguridad = useSeguridad();
    const permisoEnTaller = seguridad.tieneAcceso(constantes.opciones.permisoEnTaller);
    const puedeEditarEnTaller = permisoEnTaller && !disabled;

  const { values, setValues } = useForm();

const onChangeMerge = (delta) => {
  setValues(prev => {
    const safeDelta = { ...(delta ?? {}) };
    if (!puedeEditarEnTaller) {
      delete safeDelta.enTaller;
    }
    const next = { ...(prev ?? {}), ...safeDelta };
    if (next.enTaller === undefined) next.enTaller = prev?.enTaller;
    return next;
  });
};

  
useEffect(() => {
  if (visible && id != null) load(id);
}, [visible, id]);



const fechaTemplate = (row) => {
  if (!row?.fecha) return "";
  return new Date(row.fecha).toLocaleDateString("es-MX");
};
const load = async (id) => {
  if (id == null) return;

  const result = await api.obtener(id);
  setValues(prev => ({ ...(prev ?? {}), ...(result ?? {}) }));
};


const onSave = async () => {
  const payload = {
    ...values,
    id: values?.id ?? id,                
    enTaller: puedeEditarEnTaller ? values?.enTaller : values?.enTaller,
  };

  await api.guardar(payload);
  await onSaved();
};

return (
  <>
    <Dialog
      header={`Actualizar ${values?.numeroEconomico}`}
      visible={visible}
      style={{ width: '720px' }}
      onHide={onCancel}
    >
      <TabView>
        <TabPanel header="GENERALES">
          <Form
            values={values}
            onChange={onChangeMerge}
            formDisabled={disabled}
            className="form-container"
            columns={2}
          >
            <Field label="Patio" field="patioId" source="patios" render={FormDropDown} showClear={true} cols={2} />
            <Field label="Unidad de Negocio" field="unidadNegocioId" source="unidadesNegocio" render={FormDropDown} showClear={true} cols={2} />
            <Field label="Cargada" field="cargada" render={FormCheckBox} />
            <Field
              label="En Taller"
              field="enTaller"
              render={FormCheckBox}
              disabled={!permisoEnTaller || disabled}
            />
          </Form>
        </TabPanel>

        <TabPanel header="HISTORIAL">
          <DataTable
            value={values?.historial ?? []}
            emptyMessage="Sin historial"
            responsiveLayout="scroll"
          >
            <Column field="tipo" header="TIPO" />
            <Column field="fecha" header="FECHA" body={fechaTemplate} />
            <Column field="motivo" header="MOTIVO" />
            <Column field="usuario" header="USUARIO" />
            <Column field="comentarios" header="COMENTARIOS" />
          </DataTable>
        </TabPanel>
      </TabView>

      <div className="form-footer">
        {!disabled &&
          <Button label="Guardar" className="p-button-outlined" type="button" onClick={onSave} />
        }
      </div>
    </Dialog>
  </>
);
}

export default InventarioCajaDetalle;
